<template>
  <b-card class="rounded-0">
    <h4>{{ title }}
      <b-badge variant="primary" class="ml-2 px-3">{{ items.length }}</b-badge>
      <span class="float-right">
        <b-button size="md"
                  variant="link"
                  class="btn-link"
                  aria-controls="collapseId"
                  :aria-expanded="showCollapse ? 'true' : 'false'"
                  @click="showCollapse = !showCollapse">
          <span v-if="!showCollapse" class="ti-angle-up"></span>
          <span v-else class="ti-angle-down"></span>
        </b-button>
      </span>
    </h4>
    <b-collapse :id="collapseId" v-model="showCollapse">
      <b-table striped
              hover
               responsive
               :fields="fields"
               :items="items"
               tbody-tr-class="show-cursor"
               tbody-class="text-muted">
        <template slot="contractPartner.contractPartnerName" slot-scope="row">
          <div @click="showDetails(row)" :class="{'text-danger' : !row.item.isComplete}">{{ row.item.contractPartner ? row.item.contractPartner.contractPartnerName : '' }}</div>
        </template>
        <template slot="contractType" slot-scope="row">
          <div @click="showDetails(row)" :class="{'text-danger' : !row.item.isComplete}">{{ row.item.contractType }}</div>
        </template>
        <template slot="cancellationPeriod" slot-scope="row">
          <div @click="showDetails(row)" :class="{'text-danger' : !row.item.isComplete}">
            {{ getCancellationPeriodText(row.item.cancellationPeriod) }}
          </div>
        </template>
      </b-table>
      <div v-if="!items || items.length === 0"
           class="text-center">
        {{ $t('message.contractsCard.noItems') }}
      </div>
    </b-collapse>
  </b-card>
</template>
<script>
  export default {
    name: 'ContractsCard',
    props: {
      collapseId: {
        type: String,
        required: true
      },
      phView: {
        type: Boolean,
        default: false
      },
      title: {
        type: String,
        required: true
      },
      items: {
        type: Array,
        default: function () {
          return []
        }
      }
    },
    data () {
      return {
        showCollapse: true,
        fields: [{
          key: 'contractPartner.contractPartnerName',
          label: this.$t('message.contactPersonDetails.contractsCard.company')
        }, {
          key: 'contractType',
          label: this.$t('message.contactPersonDetails.contractsCard.type')
        }, {
          key: 'cancellationPeriod',
          label: this.$t('message.contactPersonDetails.contractsCard.cancellationPeriod'),
          formatter: (value) => {
            if (value && value === 1) {
              return this.$t('message.contractsCard.cancellationPeriod.month', {value: value})
            } else if (value && value > 1) {
              return this.$t('message.contractsCard.cancellationPeriod.months', {value: value})
            }
            return value
          }
        }, {
          key: 'actions',
          label: ''
        }]
      }
    },
    methods: {
      getCancellationPeriodText (value) {
        if (value && value === 1) {
          return this.$t('message.contractsCard.cancellationPeriod.month', {value: value})
        } else if (value && value > 1) {
          return this.$t('message.contractsCard.cancellationPeriod.months', {value: value})
        }
        return value
      },
      showDetails (row) {
        this.$emit('showDetails', row.item)
      }
    }
  }
</script>
<style scoped>
  .btn-link {
    color: #6c757d;
    text-decoration: none;
  }

  .btn-link:hover {
    color: #21272d;
  }

</style>

<style>
  .show-cursor{cursor:pointer;}
</style>



// WEBPACK FOOTER //
// src/components/contracts/ContractsCard.vue